import Vue from 'vue';

export class RelatorioAlertas {

    /**
     *
     * @return {Promise}
     */
    static grid(uuid, json) {
        return new Promise((ok, fail) => {
            Vue.http.post('veiculo/' + uuid + '/alertas/grid', json)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

}
